import React from "react";
import Box from "@mui/material/Box";
import LogoImg from "../assets/images/logo.png";
import { SxProps, Theme } from '@mui/material/styles';

interface LogoProps {
  sx?: SxProps<Theme>
}

function Logo({ sx }: LogoProps) {
  return (
    <Box
      component="img"
      alt="Netflix Logo"
      src={LogoImg}
      width={"100%"}
      sx={{
        ...sx,
      }}
    />
  );
}

export default Logo;
